/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import { React } from "react";
import Carousel from 'react-material-ui-carousel';
import PropTypes from "prop-types";
import { Paper,Typography } from "@mui/material";

const typographyStyledTitle = {
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxHeight: 300,
    display: "-webkit-box",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
};
  

export default function ASCarousel(props) {
    const {items} = props;

    return (
        <Carousel>
            {   items &&
                items.map( (item) => 
                <Paper
                    sx={{
                    minWidth: 20
                    }}
                >
                    {item.text && 
                    <Typography
                    gutterBottom
                    variant='h5'
                    color='primary.contrastText'
                    sx={typographyStyledTitle}
                    >
                    {item.text}
                    </Typography>
                    }
                </Paper>
                )
            }
        </Carousel>
    )
}

ASCarousel.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired
};